// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FnEH","toggle":"styles_toggle__k7MPg","preview":"styles_preview__3A4M4"};